import { createReducer, on } from '@ngrx/store';
import { handleFailure, handleRequest, handleSuccess } from '@shared/ngrx-factory/factory.reducer';
import * as TerminalOperatorsActions from './terminal-operators.actions';

const initialRequestState: TerminalOperatorsActions.RequestState<any> = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialTerminalOperatorsState: TerminalOperatorsActions.TerminalOperatorsState = {
  terminalOperators: { ...initialRequestState },
  terminalOperatorByUuid: { ...initialRequestState },
  updateTerminalTank: { ...initialRequestState },
};

export const terminalOperatorsReducer = createReducer(
  initialTerminalOperatorsState,

  on(TerminalOperatorsActions.TerminalOperatorsListActions.request, (state) =>
    handleRequest(state, 'terminalOperators'),
  ),
  on(TerminalOperatorsActions.TerminalOperatorsListActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalOperators', response),
  ),
  on(TerminalOperatorsActions.TerminalOperatorsListActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalOperators', error),
  ),

  on(TerminalOperatorsActions.TerminalOperatorByUuidActions.request, (state) =>
    handleRequest(state, 'terminalOperatorByUuid'),
  ),
  on(TerminalOperatorsActions.TerminalOperatorByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalOperatorByUuid', response),
  ),
  on(TerminalOperatorsActions.TerminalOperatorByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalOperatorByUuid', error),
  ),

  on(TerminalOperatorsActions.UpdateTerminalTankActions.request, (state) =>
    handleRequest(state, 'updateTerminalTank'),
  ),
  on(TerminalOperatorsActions.UpdateTerminalTankActions.success, (state, { response }) =>
    handleSuccess(state, 'updateTerminalTank', response),
  ),
  on(TerminalOperatorsActions.UpdateTerminalTankActions.failure, (state, { error }) =>
    handleFailure(state, 'updateTerminalTank', error),
  ),
);
